import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { fetchCircleAuthToken } from '../CircleCommunityPage/CircleCommunityPage.duck';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';

export const loadData = (params, search) => async (dispatch, getState) => {
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
  };

  const { currentUser } = getState().user;
  try {
    if (!currentUser) {
      await dispatch(fetchCurrentUser());
    }
  } catch (e) {
    console.log(e, '&&& &&& => e');
  }

  return Promise.all([
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(fetchCircleAuthToken({})),
  ]);
};
